"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const query_string_1 = require("query-string");
const database_1 = __importDefault(require("../helpers/database"));
const __1 = require("..");
class Retailers {
    static async GetOnlineListing() {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let data = await axios_1.default.get(`${__1.Config.ONLINE_API_URL}/api/get-retailers`, options);
            return data.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            let error = 1;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
                error = e.response.status;
            }
            return {
                message: message,
                error: error
            };
        }
    }
    static async GetOfflineListing(role) {
        try {
            let sql_res = await database_1.default.Query(`select retailer_id, row_order, organization from retailer_meta`, []);
            if (role === 'sdm_viewer') {
                sql_res = await database_1.default.Query(`select retailer_id, row_order, organization from retailer_meta where retailer_id = ?`, [9]);
            }
            let result = database_1.default.ConvertResultSetToArray(sql_res);
            for (let index in result) {
                sql_res = await database_1.default.Query(`select * from retailers where retailer_id = ? LIMIT 1`, [result[index].retailer_id]);
                result[index]['retailer'] = database_1.default.ConvertResultSetToObject(sql_res);
            }
            return result;
        }
        catch (e) {
            return {
                error: 1,
                message: `Something went wrong while accessing local storage`
            };
        }
    }
    static async GetListing(role) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlineListing();
        }
        else {
            return this.GetOfflineListing(role);
        }
    }
    static async GetOnlineStoresByRetailers(id, page) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-stores`;
            if (id) {
                url = `${url}?retailer_id=${id}`;
            }
            let data = await axios_1.default.get(url, options);
            return data.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflineStoresByRetailers(id, page) {
        try {
            const limit = 20;
            let response = {
                page: page,
                limit: limit,
                total_page_count: 1,
                total_result_count: 0,
                result: []
            };
            let [summary, stores] = await Promise.all([
                database_1.default.Query(`select ( count(*) / ${limit} ) + 1 as total_page_count, count(*) as total_result_count from stores where retailer_id = ?`, [id]),
                database_1.default.Query(`select * from stores where retailer_id = ? order by sort_id asc limit 0, ${limit}`, [id])
            ]);
            summary = database_1.default.ConvertResultSetToObject(summary);
            response.total_page_count = summary.total_page_count;
            response.total_result_count = summary.total_result_count;
            let result = database_1.default.ConvertResultSetToArray(stores);
            for (let index in result) {
                result[index] = await this.PopulateStoreDetails(result[index]);
            }
            response.result = result;
            return response;
        }
        catch (e) {
            console.log(e);
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetStoresByRetailer(id, page = 1) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlineStoresByRetailers(id, page);
        }
        else {
            return this.GetOfflineStoresByRetailers(id, page);
        }
    }
    static async SearchOnlineStores(keyword, page = 1, filter_by = "", retailer_id) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-stores`;
            let params = {
                search_term: keyword,
                page: page
            };
            if (filter_by) {
                params.filter_by = filter_by;
            }
            if (retailer_id) {
                params.retailer_id = retailer_id;
            }
            url = `${url}?${(0, query_string_1.stringify)(params)}`;
            let data = await axios_1.default.get(url, options);
            return data.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async SearchOfflineStores(keyword, page = 1, filter_by = "", retailer_id) {
        try {
            const limit = 20;
            let response = {
                page: page,
                limit: limit,
                total_page_count: 1,
                total_result_count: 0,
                result: []
            };
            let offset = (page - 1) * limit;
            if (!retailer_id && !keyword) {
                let [summary, stores] = await Promise.all([
                    database_1.default.Query(`select ( count(*) / ${limit} ) + 1 as total_page_count, count(*) as total_result_count from stores`, []),
                    database_1.default.Query(`select * from stores order by sort_id asc limit ${offset}, ${limit}`, [])
                ]);
                summary = database_1.default.ConvertResultSetToObject(summary);
                response.total_page_count = summary.total_page_count;
                response.total_result_count = summary.total_result_count;
                let result = database_1.default.ConvertResultSetToArray(stores);
                for (let index in result) {
                    result[index] = await this.PopulateStoreDetails(result[index]);
                }
                response.result = result;
                return response;
            }
            else {
                let condition = `(
                    store_name like '%${keyword}%'
                    or store_number like '%${keyword}%'
                    or (address || "," || city || "," || province || "," || postal_code like '%${keyword}%')
                    or id IN (SELECT DISTINCT store_id FROM store_meta WHERE attribute_value LIKE '%${keyword}%')
                    or id IN (SELECT DISTINCT store_id FROM store_plano_map WHERE plano_code LIKE '%${keyword}%' OR plano_title LIKE '%${keyword}%')
                )`;
                if (retailer_id && keyword) {
                    condition = `${condition} and retailer_id = ${retailer_id}`;
                }
                else if (retailer_id && !keyword) {
                    condition = `retailer_id = ${retailer_id}`;
                }
                let [summary, stores] = await Promise.all([
                    database_1.default.Query(`select ( count(*) / ${limit} ) + 1 as total_page_count, count(*) as total_result_count from stores where ${condition}`, []),
                    database_1.default.Query(`select * from stores where ${condition} order by sort_id asc limit ${offset}, ${limit}`, [])
                ]);
                summary = database_1.default.ConvertResultSetToObject(summary);
                response.total_page_count = summary.total_page_count;
                response.total_result_count = summary.total_result_count;
                let result = database_1.default.ConvertResultSetToArray(stores);
                for (let index in result) {
                    result[index] = await this.PopulateStoreDetails(result[index]);
                }
                response.result = result;
                return response;
            }
        }
        catch (e) {
            console.log(e);
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async SearchStores(keyword, page, filter_by = "", retailer_id) {
        if (__1.Config.IS_ONLINE) {
            return this.SearchOnlineStores(keyword, page, filter_by, retailer_id);
        }
        else {
            return this.SearchOfflineStores(keyword, page, filter_by, retailer_id);
        }
    }
    static async GetOnlineStore(id) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-stores`;
            if (id) {
                url = `${url}?store_id=${id}`;
            }
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            if (_data.result.length > 0) {
                return _data.result[0];
            }
            else {
                return {
                    message: `Can't find store by specified id`,
                    error: 1
                };
            }
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflineStore(id) {
        try {
            let sql_res = await database_1.default.Query(`select * from stores where id = ? limit 1`, [id]);
            let store = database_1.default.ConvertResultSetToObject(sql_res);
            return this.PopulateStoreDetails(store);
        }
        catch (e) {
            console.log(e);
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetStore(id) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlineStore(id);
        }
        else {
            return this.GetOfflineStore(id);
        }
    }
    static async GetOnlineStoreTesters(brands) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let params = {
                brand: brands
            };
            let url = `${__1.Config.ONLINE_API_URL}/api/get-tester?${(0, query_string_1.stringify)(params)}`;
            let data = await axios_1.default.get(url, options);
            return data.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflineStoreTesters(brands) {
        try {
            const limit = 20;
            let response = {
                page: 1,
                limit: limit,
                total_page_count: 1,
                total_result_count: 0,
                result: []
            };
            let index = 0;
            for (let item of brands) {
                brands[index] = `'${item}'`;
                index++;
            }
            let [testers, summary] = await Promise.all([
                database_1.default.Query(`select * from testers where brand in (${brands.join(",")}) limit 0, ${limit}`, []),
                database_1.default.Query(`select ( count(*) / ${limit} ) + 1 as total_page_count, count(*) as total_result_count from testers where brand in (${brands.join(",")})`, []),
            ]);
            response.result = database_1.default.ConvertResultSetToArray(testers);
            summary = database_1.default.ConvertResultSetToObject(summary);
            response.total_page_count = summary.total_page_count;
            response.total_result_count = summary.total_result_count;
            return response;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetStoreTesters(brands) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlineStoreTesters(brands);
        }
        else {
            return this.GetOfflineStoreTesters(brands);
        }
    }
    static async GetOnlinePlanogram(plano_code) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-planogram?plano_code=${plano_code}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            if (_data.total_result_count > 0) {
                return _data.result[0];
            }
            else {
                return {
                    message: `Can't access planogram by specified code`,
                    error: 1
                };
            }
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflinePlanogram(plano_code) {
        try {
            let planogram = await database_1.default.Query(`select * from planogram where plano_code = '${plano_code}' limit 1`, []);
            planogram = database_1.default.ConvertResultSetToObject(planogram);
            return planogram;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetPlanogram(plano_code) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlinePlanogram(plano_code);
        }
        else {
            return this.GetOfflinePlanogram(plano_code);
        }
    }
    static async GetOnlinePlanogramFixtures(plano_code) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-fixtures?plano_code=${plano_code}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            return _data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflinePlanogramFixtures(plano_code) {
        try {
            let fixtures = await database_1.default.Query(`select * from fixtures where plano_code = ? and is_pseudo_fixture=0`, [plano_code]);
            fixtures = database_1.default.ConvertResultSetToArray(fixtures);
            for (let index in fixtures) {
                let item = fixtures[index];
                let components = await database_1.default.Query(`select * from fixture_components where fixture_code = ? AND (location is null OR (location = ? AND plano_code = ?)) order by sort_id`, [item.fixture_code, item.location, item.plano_code]);
                components = database_1.default.ConvertResultSetToArray(components);
                for (let _index in components) {
                    let _item = components[_index];
                    let details = await database_1.default.Query(`select * from components where component_code = ? limit 1`, [_item.component_code]);
                    details = database_1.default.ConvertResultSetToArray(details);
                    components[_index].details = details;
                }
                fixtures[index].components = components;
            }
            return fixtures;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetPlanogramFixtures(plano_code) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlinePlanogramFixtures(plano_code);
        }
        else {
            return this.GetOfflinePlanogramFixtures(plano_code);
        }
    }
    static async GetOnlinePlanogramProducts(plano_code) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-products?plano_code=${plano_code}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            return _data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflinePlanogramProducts(plano_code) {
        try {
            let products = await database_1.default.Query(`select * from products where plano_code = '${plano_code}'`, []);
            products = database_1.default.ConvertResultSetToArray(products);
            return products;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetPlanogramProducts(plano_code) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlinePlanogramProducts(plano_code);
        }
        else {
            return this.GetOfflinePlanogramProducts(plano_code);
        }
    }
    static async GetOnlinePlanogramRelineInstructions(plano_code) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-instructions?plano_code=${plano_code}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            return _data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflinePlanogramRelineInstructions(plano_code) {
        try {
            let reline_instructions = await database_1.default.Query(`select * from instructions where instruction_code in (select instruction_code from instructions_plano_map where plano_code = '${plano_code}') order by instruction_order asc`, []);
            reline_instructions = database_1.default.ConvertResultSetToArray(reline_instructions);
            return reline_instructions;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetPlanogramRelineInstructions(plano_code) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlinePlanogramRelineInstructions(plano_code);
        }
        else {
            return this.GetOfflinePlanogramRelineInstructions(plano_code);
        }
    }
    static async GetOnlinePlanogramIndividualComponents(plano_brand) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-individual-components?brand=${plano_brand}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            return _data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflinePlanogramIndividualComponents(plano_brand) {
        try {
            const limit = 20;
            let response = {
                page: 1,
                limit: limit,
                total_page_count: 1,
                total_result_count: 0,
                result: []
            };
            let individual_components = await database_1.default.Query(`select * from components where brand='${plano_brand}' AND is_individual = 1`, []);
            individual_components = database_1.default.ConvertResultSetToArray(individual_components);
            response.result = individual_components;
            return response;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetPlanogramIndividualComponents(plano_brand) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlinePlanogramIndividualComponents(plano_brand);
        }
        else {
            return this.GetOfflinePlanogramIndividualComponents(plano_brand);
        }
    }
    static async GetOnlinePlanogramPseudoFixtures(plano_code) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-pseudo-fixtures?plano_code=${plano_code}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            return _data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflinePlanogramPseudoFixtures(plano_code) {
        try {
            let fixtures = await database_1.default.Query(`select * from fixtures where plano_code = ? and is_pseudo_fixture=1`, [plano_code]);
            fixtures = database_1.default.ConvertResultSetToArray(fixtures);
            for (let index in fixtures) {
                let item = fixtures[index];
                let components = await database_1.default.Query(`select * from fixture_components where fixture_code = ?`, [item.fixture_code]);
                components = database_1.default.ConvertResultSetToArray(components);
                for (let _index in components) {
                    let _item = components[_index];
                    let details = await database_1.default.Query(`select * from components where component_code = ? limit 1`, [_item.component_code]);
                    details = database_1.default.ConvertResultSetToArray(details);
                    components[_index].details = details;
                }
                fixtures[index].components = components;
            }
            return fixtures;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetPlanogramPseudoFixtures(plano_code) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlinePlanogramPseudoFixtures(plano_code);
        }
        else {
            return this.GetOfflinePlanogramPseudoFixtures(plano_code);
        }
    }
    static async GetOnlinePlanogramFiles(plano_code, file_type) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let urlParams = {};
            if (plano_code) {
                urlParams['plano_code'] = plano_code;
            }
            if (file_type) {
                urlParams['file_type'] = file_type;
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-files?${(0, query_string_1.stringify)(urlParams)}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            return _data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflinePlanogramFiles(plano_code, file_type) {
        try {
            let condition = '';
            if (plano_code) {
                condition += ` AND file_id in (select file_id from file_plano_map where plano_code = '${plano_code}')`;
            }
            if (file_type) {
                condition += ` AND file_type = '${file_type}'`;
            }
            let files = await database_1.default.Query(`select * from files where 1 ${condition}`, []);
            files = database_1.default.ConvertResultSetToArray(files);
            return files;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetPlanogramFiles(plano_code, type = __1.PlanogramFileType.MEMO) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlinePlanogramFiles(plano_code, type);
        }
        else {
            return this.GetOfflinePlanogramFiles(plano_code, type);
        }
    }
    static async GetOnlineProjects(plano_brand) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-active-projects?plano_brand=${plano_brand}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            return _data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetOfflineProjects(plano_brand, role) {
        try {
            let projects = await database_1.default.Query(`select project_code, project_name from projects where plano_brand='${plano_brand}' order by sort_order`, []);
            if (role === 'sdm_viewer') {
                projects = await database_1.default.Query(`select project_code, project_name from projects where plano_brand='${plano_brand}' and role='sdm_viewer' order by sort_order`, []);
            }
            projects = database_1.default.ConvertResultSetToArray(projects);
            return projects;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetProjects(plano_brand, role) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlineProjects(plano_brand);
        }
        else {
            return this.GetOfflineProjects(plano_brand, role);
        }
    }
    static async AssignStorePlanogram(store_id, plano_code) {
        try {
            const options = {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/assign-planogram-store`;
            let response = await axios_1.default.post(url, {
                store_id: store_id,
                plano_code: plano_code
            }, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async UnassignStorePlanogram(store_id, plano_code) {
        try {
            const options = {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/unassign-planogram-store`;
            let response = await axios_1.default.post(url, {
                store_id: store_id,
                plano_code: plano_code
            }, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async SearchPlanogram(keyword) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/get-planogram?search_term=${keyword}`;
            let data = await axios_1.default.get(url, options);
            let _data = data.data;
            if (_data.total_result_count > 0) {
                return _data.result;
            }
            else {
                return [];
            }
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async SaveStore(id, data) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/add-store`;
            if (id) {
                url = `${__1.Config.ONLINE_API_URL}/api/admin/update-store?store_id=${id}`;
            }
            let response = await axios_1.default.post(url, data, options);
            if (!id) {
                id = response.data.store_id;
            }
            return {
                message: response.data.detail,
                store_id: id
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async SaveStoreMeta(id, data) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/add-store-meta?store_id=${id}`;
            let response = await axios_1.default.post(url, data, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async DeleteStore(id) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/admin/delete-store`;
            let response = await axios_1.default.post(url, {
                store_id: id
            }, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async PopulateStoreDetails(store) {
        let sql_res = await database_1.default.Query(`select * from retailers where retailer_id = ? LIMIT 1`, [store.retailer_id]);
        store.retailer = database_1.default.ConvertResultSetToObject(sql_res);
        sql_res = await database_1.default.Query(`select spm.* from store_plano_map spm, planogram p where spm.plano_code = p.plano_code and spm.store_id = ?`, [store.id]);
        store.planograms = database_1.default.ConvertResultSetToArray(sql_res);
        sql_res = await database_1.default.Query(`select * from store_meta where store_id = ?`, [store.id]);
        store.additional_values = database_1.default.ConvertResultSetToArray(sql_res);
        return store;
    }
    static async GetOfflinePlanogramMoves(plano_code) {
        try {
            let sql_res = await database_1.default.Query(`select * from moves where plano_code = ? `, [plano_code]);
            const result = database_1.default.ConvertResultSetToArray(sql_res);
            return result;
        }
        catch (e) {
            return {
                message: `Something went wrong while accessing local storage`,
                error: 1
            };
        }
    }
    static async GetOnlinePlanogramMoves(plano_code) {
        try {
            const options = {
                withCredentials: true
            };
            let url = `${__1.Config.ONLINE_API_URL}/api/v1/internal/api/get-moves?plano_code=${plano_code}`;
            let response = await axios_1.default.get(url, options);
            return response.data;
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
    static async GetPlanogramMoves(plano_code) {
        if (__1.Config.IS_ONLINE) {
            return this.GetOnlinePlanogramMoves(plano_code);
        }
        else {
            return this.GetOfflinePlanogramMoves(plano_code);
        }
    }
    /**
     * @deprecated since version 1.0.52
     */
    static async SaveOrder(data) {
        try {
            const options = {
                withCredentials: true
            };
            if (__1.Config.IS_CLI) {
                options.headers = {
                    Cookie: __1.Config.GetCookie()
                };
            }
            let url = `${__1.Config.ONLINE_API_URL}/api/create-orders`;
            let response = await axios_1.default.post(url, data, options);
            return {
                message: response.data.detail
            };
        }
        catch (e) {
            let message = `Can't access API server at this moment, please try again later`;
            if (e.response && e.response.data && e.response.data.detail) {
                message = e.response.data.detail;
            }
            return {
                message: message,
                error: 1
            };
        }
    }
}
exports.default = Retailers;
;
